import React, { useState } from 'react';
import logo from '../../../logo.png';
import { Link } from 'react-router-dom';
import { AiOutlineClose } from 'react-icons/ai';
import { FiBarChart2 } from 'react-icons/fi'
// import { BsChevronBarLeft } from 'react-icons/bs'

const Navbar = () => {

    const links = [
        {
            id: 1,
            name: "Home",
            href: "/"
        },
        {
            id: 2,
            name: "About",
            href: "/about"
        },
        {
            id: 3,
            name: "Skills",
            href: "/skills"
        },
        {
            id: 4,
            name: "Projects",
            href: "/projects"
        },
        {
            id: 5,
            name: "Services",
            href: "/services"
        },
        {
            id: 6,
            name: "Contact",
            href: "/contact"
        },
        {
            id: 7,
            name: "Blogs",
            href: "/blogs"
        },
    ]

    const [btnState, setBtnState] = useState(false);

    const barBtn = () => {
        setBtnState(!btnState);
    }

    return (
        <div className="bg-[url('/src/bg.png')] md:h-[120px]">
            <nav className="border-gray-200 px-2 sm:px-4 py-2.5 rounded">
                <div className="container flex flex-wrap items-center justify-between mx-auto">
                    <Link to="/" className="flex items-center">
                        <img src={logo} className="h-24 mr-3" alt=" Logo" />
                        <h1 className='md:text-4xl -mt-4 -ml-5 md:-ml-0 text-2xl font-semibold'>Nusrat Jahan</h1>
                    </Link>
                    <button data-collapse-toggle="navbar-default" type="button" className="inline-flex items-center p-2 mr-4 text-sm text-gray-500 rounded-lg md:hidden -mt-3 toggle" aria-controls="navbar-default" onClick={barBtn}>
                        <FiBarChart2 className='text-4xl'></FiBarChart2>
                    </button>
                    <div className={`${btnState === false ? 'hidden' : 'block nav-btn rounded-lg'} w-full md:block md:w-auto`} id="navbar-default">
                        <ul className={`flex flex-col p-4 mt-4 rounded-lg md:flex-row md:gap-4 md:items-center md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0`}>
                            <li>
                                <button className={`${btnState === false ? 'hidden' : 'block'} py-2 pl-3 pr-4 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0`} onClick={() => setBtnState(false)}><AiOutlineClose></AiOutlineClose></button>
                            </li>
                            {
                                links.map(link =>
                                    <li key={link.id}>
                                        <Link to={link.href} className="block py-2 pl-3 pr-4 text-lg text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0" onClick={() => setBtnState(false)}>{link.name}</Link>
                                    </li>
                                )
                            }
                        </ul>
                    </div>
                </div>
            </nav>

        </div>
    );
};

export default Navbar;